import classes from '../../Classes';
var fullWidth = function fullWidth() {
  return {
    getGridAlignment: function getGridAlignment() {
      return classes.GRID_ALIGNMENT.START;
    },
    getAlignment: function getAlignment() {
      return classes.ALIGNMENT.LEFT;
    },
    getVerticalAlignment: function getVerticalAlignment() {
      return classes.VERTICAL_ALIGNMENT.BOTTOM;
    }
  };
};
export default fullWidth;